/**
 * Copyright (c) 2023 Wizart Animation.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Wizart Animation.
 */

const formatRegExp = /^(?<format>video|image)\//;

const getFormat = (srcType) => {
    if (srcType) {
        const match = srcType.match(formatRegExp);
        if (match) return match.groups.format;
    }
};

export default getFormat;
